import React from "react";
import type { CrossPromoBlock } from "@/types/product";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import shared from "../ProductDetailContent.module.css";
import styles from "./CrossPromoSection.module.css";

function ArrowRight() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="14"
      height="14"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      aria-hidden="true"
    >
      <path d="M5 12h14M13 5l7 7-7 7" />
    </svg>
  );
}

export const CrossPromoSection: React.FC<{ block: CrossPromoBlock }> = ({
  block,
}) => {
  const hasImage = Boolean(block.image?.url);
  const isImageLeft = hasImage && block.imagePosition === "left";
  const ctaHref = block.ctaLink?.url;
  const isSafeCtaHref =
    !!ctaHref && !/^\s*(javascript|data|vbscript):/i.test(ctaHref);
  const ctaOpensNewTab = block.ctaLink?.target === "_blank";
  const ctaLabel = block.ctaLink?.name?.trim() || ctaHref;

  return (
    <section className={`${shared.section} ${shared.bgMint}`}>
      <div
        className={`${styles.inner} ${hasImage ? "" : styles.noImage} ${
          isImageLeft ? styles.imageLeft : ""
        }`}
      >
        <div className={styles.copy}>
          {block.heading && <h2 className={styles.heading}>{block.heading}</h2>}
          {block.text && (
            <div
              className={styles.text}
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(block.text) }}
            />
          )}
          {isSafeCtaHref && ctaLabel && (
            <a
              href={ctaHref}
              target={ctaOpensNewTab ? "_blank" : undefined}
              rel={ctaOpensNewTab ? "noopener noreferrer" : undefined}
              className={styles.cta}
            >
              {ctaLabel}
              <ArrowRight />
            </a>
          )}
        </div>
        {hasImage && (
          <div
            className={styles.image}
            style={{
              backgroundImage: `url('${block.image!.url.replace(/'/g, "%27")}')`,
            }}
            aria-hidden={!block.image!.altText}
            role={block.image!.altText ? "img" : undefined}
            aria-label={block.image!.altText || undefined}
          />
        )}
      </div>
    </section>
  );
};

export default CrossPromoSection;
